export var HttpResponseBoltServer;
(function (HttpResponseBoltServer) {
    var PermissionMissingType;
    (function (PermissionMissingType) {
        PermissionMissingType["ONE_OF"] = "oneOf";
        PermissionMissingType["ALL"] = "all";
    })(PermissionMissingType = HttpResponseBoltServer.PermissionMissingType || (HttpResponseBoltServer.PermissionMissingType = {}));
})(HttpResponseBoltServer || (HttpResponseBoltServer = {}));
